import styled from 'styled-components';
import { SecondaryButton } from 'ui/button';
import { button, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

type StyledHeaderButtonProps = {
  isSortable: boolean;
  isActiveSortColumn: boolean;
  isRightAligned: boolean;
};

const customSpacing = {
  p136: pxToRem(136),
  p344: pxToRem(344),
  p1100: pxToRem(1100),
};

export const TableWrapper = styled.div`
  min-width: ${customSpacing.p1100};
  margin-top: ${spacing.base};
`;

const HeaderButton = styled.button`
  ${button}
  background: none;
  border: none;
  padding: ${spacing.half} 0;
  outline: none;

  span {
    display: inline-block;
    margin-right: ${spacing.quarter};
  }
`;

export const StyledHeaderButton = styled(HeaderButton)<StyledHeaderButtonProps>`
  text-align: left;
  color: ${(props) => {
    if (!props.isSortable) {
      return colors.textPrimary;
    }
    return props.isActiveSortColumn ? colors.brandPurple : colors.textPrimary;
  }};
  display: flex;
  align-items: center;
  ${(props) => (props.isRightAligned ? 'justify-content: flex-end;' : '')}
`;

export const NoDataContainer = styled.div`
  margin: ${customSpacing.p136} 0 ${customSpacing.p344};
`;

export const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;
